import { valueToName, isIncludeIntra, deepCopy, getConstantByKeyword, getDateDay, formatDate, getDisposeSearchCriteria } from 'service/utils'
import store from 'store'
import { model, config } from 'service/model'
import downLoad from 'C/downLoad'

export default {
    methods: {
        valueToName (groupName, key, name) {
            if (!key && key != 0) {
                return '--'
            } else {
                return valueToName(groupName, key, name)
            }
        },
        getDateDay (date) {
            return getDateDay(date)
        },
        formatDate (date, fmt) {
            return formatDate(new Date(date), fmt)
        },
        updatePagedData (obj, data) {
            obj.isFirstLoad = false
            obj.pageSize = data.per_page
            obj.totalCount = data.total
            return obj
        },
        updateBtn () {
            return isIncludeIntra('day')
        },
        convert (arr, str) { // 过滤停用组织结构
            let newArr = deepCopy(arr);
            return newArr.filter(item => {
                if (item.child) {
                    item.child = this.convert(item.child, str)
                }
                if (str) {
                    return item[str] === undefined || item[str] == 1
                } else {
                    return item.dep_status == 1
                }
            })
        },
        percentToColor (percent) {
            const per = Number(percent)
            if (0 < per && per <= 50) {
                return '#f30'
            }
            if (50 < per && per <= 70) {
                return '#ff9900'
            }
            if (70 < per) {
                return '#3c0'
            }
        }
    },
}

const userMess = {
    data: function () {
        return {
            userMess: store.getters['auth/user'].thisUserMess
        }
    }
}

/*
表格是否需要支持以下操作
需要table添加ref="multipleTable" 
*/
const tableConstant = {
    data: function () {
        return {
            actionItemNumber: 0,
            actionItemWidth: 0,
            RESIZABLE: false,
            idKey: 'person_id', // 标识当前行的唯一键的名称
            optStyle: false, // 操作按钮样式控制
            showIndex: config.isSupportListConfig && true, //是否显示索引
            showMultiple: config.isSupportListConfig && true, //是否支持多选功能
            supportMultipageIndexList: false, //支持跨页选择列表项——必须先支持多选
            hideMultiple: config.isSupportListConfig && true, //没有对应操作功能权限的时候是否去掉多选功能列
            hideHandleList: config.isSupportListConfig && true, //没有操作项权限的时候是否去掉操作列
            multipleSelection: [], //当前页选中的数据
            multipleSelectionAll: [], //跨页数据集
            pagingObj: {
                isFirstLoad: true,
                currentPage: 1,
                pageSize: 20,
                totalCount: 0
            },
            dataScope: store.getters['auth/roleCacheData'].rights[this.$route.path] ? store.getters['auth/roleCacheData'].rights[this.$route.path].data_scope : 7, //数据范围
            isDisabledFilialeSelect: false,
            isDisabledShowSchoolSelect: false,
            isShowFilialeAndSchoolSelect: false,
        }
    },
    watch: {
        thisFunction: {
            handler (newVal, oldVal) {
                if (!newVal || !newVal.actionItem) {
                    return false
                }
                this.actionItemNumber = Object.values(newVal.actionItem).reduce((res, c) => {
                    res[c] ? res[c]++ : res[c] = 1;
                    return res
                }, {}).true
                this.actionItemWidth = 28 * this.actionItemNumber + (this.actionItemNumber - 1) * 5.334 + 22
            },
            immediate: true
        },
        dataScope: {
            handler (newVal, oldVal) {
                switch (newVal) {
                    case 1: //集团
                        this.isDisabledFilialeSelect = true
                        this.isDisabledShowSchoolSelect = true
                        this.isShowFilialeAndSchoolSelect = true
                        break;
                    case 2: //分公司
                        this.isDisabledShowSchoolSelect = true
                        this.isShowFilialeAndSchoolSelect = true
                        break;
                    case 3: //校区
                        this.isShowFilialeAndSchoolSelect = true
                        break;
                    case 4: //部门权限
                        let uM = store.getters['auth/user'].thisUserMess
                        if (uM.school_id == 0 && uM.branch_id == 0) {// 集团部门权限
                            this.isDisabledFilialeSelect = true
                            this.isDisabledShowSchoolSelect = true
                            this.isShowFilialeAndSchoolSelect = true

                        }
                        if (uM.school_id == 0 && uM.branch_id != 0) { // 分公司部门权限
                            this.isDisabledFilialeSelect = false
                            this.isDisabledShowSchoolSelect = true
                            this.isShowFilialeAndSchoolSelect = true
                        }
                        if (uM.school_id != 0) { // 校区部门权限
                            this.isDisabledFilialeSelect = false
                            this.isDisabledShowSchoolSelect = false
                            this.isShowFilialeAndSchoolSelect = true
                        }
                        break;
                    case 7: //个人
                        this.isShowFilialeAndSchoolSelect = true
                        break;
                    default: this.isShowFilialeAndSchoolSelect = false
                }
            },
            immediate: true
        }
    },
    beforeMount: function () {
        if (this.searchJson) {
            this.searchJson.api_key = store.getters['auth/roleCacheData'].rights[this.$route.path].role_data_range
        }
    },
    methods: {
        searchCallback () {
            this.pagingObj.currentPage = 1
            setTimeout(() => {
                this.getList()
            }, 500)
        },
        handleCurrentChange (val) {
            if (this.supportMultipageIndexList) {
                this.changePageCoreRecordData();
            }
            this.pagingObj.currentPage = val
            this.getList()
        },
        handleSelectionChange (val) {
            this.multipleSelection = val
            this.$emit('multiCallback', val)
        },
        // 多选的情况下设置选中
        setSelectRow () {
            if (!this.multipleSelectionAll || this.multipleSelectionAll.length <= 0) {
                return;
            }
            // 标识当前行的唯一键的名称
            let idKey = this.idKey;
            let selectAllIds = [];
            let that = this;
            this.multipleSelectionAll.forEach(row => {
                selectAllIds.push(row[idKey]);
            })
            this.$refs.multipleTable.clearSelection();
            for (var i = 0; i < this.tableData.length; i++) {
                if (selectAllIds.indexOf(this.tableData[i][idKey]) >= 0) {
                    // 设置选中，ref="multipleTable"
                    this.$refs.multipleTable.toggleRowSelection(this.tableData[i]);
                }
            }
        },
        // 多选情况下 记录选择
        changePageCoreRecordData () {
            // 标识当前行的唯一键的名称
            let idKey = this.idKey;
            let that = this;
            // 如果multipleSelectionAll中还没有选择的数据，return
            if (this.multipleSelectionAll.length <= 0) {
                this.multipleSelectionAll = this.multipleSelection;
                return;
            }
            // multipleSelectionAll里面的key集合
            let selectAllIds = [];
            this.multipleSelectionAll.forEach(row => {
                selectAllIds.push(row[idKey]);
            })
            let selectIds = []
            // 获取当前页选中的id
            this.multipleSelection.forEach(row => {
                selectIds.push(row[idKey]);
                // 如果multipleSelectionAll里面不包含当前页选中的数据，那么就加入到总选择集合里
                if (selectAllIds.indexOf(row[idKey]) < 0) {
                    that.multipleSelectionAll.push(row);
                }
            })
            let noSelectIds = [];
            // 得到当前页没有选中的id
            this.tableData.forEach(row => {
                if (!selectIds.includes(row[idKey])) {
                    noSelectIds.push(row[idKey]);
                }
            })
            noSelectIds.forEach(id => {
                if (selectAllIds.includes(id) >= 0) {
                    for (let i = 0; i < that.multipleSelectionAll.length; i++) {
                        if (that.multipleSelectionAll[i][idKey] == id) {
                            // 如果multipleSelectionAll中有未被选中的，那么就删除这条
                            that.multipleSelectionAll.splice(i, 1);
                            break;
                        }
                    }
                }
            })
        },
        // 获取所有选中数据
        getAllSelectionData () {
            this.changePageCoreRecordData()
            return this.multipleSelectionAll
        },
        defineSort (column) {
            this.searchJson.orderkey = column.prop
            this.searchJson.ordervalue = column.order ? column.order.match(/(\S*)ending/)[1] : ''
            this.getList()
        },
        // 切换操作按钮样式
        changeStyleOpt (column, ref) {
            if (column.label == '操作') {
                this.optStyle = !this.optStyle
                this.$nextTick(() => {
                    this.$refs[ref] && this.$refs[ref].doLayout()
                })
            }
        }
    }
}

const submitIng = {
    data: function () {
        return {
            isCanSubmit: false
        }
    }
}


/*
@默认展示当前人所在分公司和校区
dataScope:  1 集团 分公司/校区不给默认值
            2 分公司 分公司默认当前分公司；如果存在校区 默认当前校区，否则 不给默认值
            3 校区 分公司/校区 默认当前分公司校区
            4 部门
            5
            6 
            7 个人
*/
const filialeAndSchoolSearch = {
    data () {
        return {
            loading: false, //列表加载loading
            tableData: [], //列表数据集
            branchOption: [], //分公司集
            schoolOption: [], //校区集
            immediateChange: true, // 分公司校区改变立刻获取数据
            isFirstLoadList: true //是否第一次加载、主要判断是否需要在切换校区以后拉取数据、默认第一次判断完校区以后会拉取一次
        }
    },
    created: function () {
        this.branchOption = getConstantByKeyword('filiale')
    },
    watch: {
        userMess: {
            handler (newVal, oldVal) {
                this.$nextTick(() => {
                    if (this.branch_school) {
                        this.searchJson.branch_id = ''
                    } else if (newVal && newVal.branch_id) {
                        this.searchJson.branch_id = newVal.branch_id
                    } else if (this.dataScope && this.dataScope == 4) {
                        this.searchJson.branch_id = ''
                        this.isFirstLoadList = false
                        this.getList()
                    } else {
                        this.searchJson.branch_id = (this.branchOption)[0].id
                    }
                    /* this.authDataScopeMisstion() // 新的权限判断 */
                })
            },
            immediate: true
        },
        branch_id: {
            handler (newVal, oldVal) {
                if (this.branchOption && this.branchOption.length) {
                    this.getSchoolList(newVal)
                } else {
                    setTimeout(() => {
                        this.getSchoolList(newVal)
                    }, 500)
                }
                if (this.isFirstLoadList && this.paramsFilter && this.paramsFilter.includes('school')) {
                    this.isFirstLoadList = false
                    this.getList()
                }
            }
        },
        school_id: {
            handler (newVal, oldVal) {
                if ( /*newVal && */ this.isFirstLoadList) {
                    this.isFirstLoadList = false
                    this.getList()
                }
            }
        },
    },
    computed: {
        branch_id () {
            return this.searchJson.branch_id
        },
        school_id () {
            return this.searchJson.school_id
        }
    },
    methods: {
        getSchoolList (val) {
            let result = this.branchOption
            if (!val) {
                this.schoolOption = []
                this.searchJson.school_id = ''
                return false
            }
            this.schoolOption = result.filter(item => {
                return item.id == val
            })[0].child.filter(item => {
                return item.dep_type == 3
            })
            if (this.paramsFilter && this.paramsFilter.includes('school')) return
            this.searchJson.school_id = this.userMess.school_id || (this.schoolOption)[0].id
        },
        getList () {
            this.searchJson.page = this.pagingObj.currentPage || 1
            this.loading = true
            this.tableData = []
            let tempSearchJson = getDisposeSearchCriteria(this.searchJson, this.time, this.inputDate)
            this.fetch(model[this.listUrl], {
                params: tempSearchJson
            }).then(res => {
                let data = res.data || res
                this.tableData = data.map(item => {
                    item.loading = false // 按钮触发状态
                    item.showRemind = item.order_status == 1 || item.o_status == 1 // 仅作为【产品购买记录菜单】【充值订单列表】提醒按钮显示判断
                    return item
                })
                if (res.totalStatis) {
                    this.statisticArray = res.totalStatis
                }
                if (this.isUnd == false) {
                    this.isUnd = true
                }
                this.pagingObj = this.updatePagedData(this.pagingObj, res)
                this.loading = false
            }, data => {
                this.loading = false
                this.$message({
                    message: data,
                    type: 'error'
                })
            })
        },
        authDataScopeMisstion () {
            const u = this.userMess
            if (this.dataScope) {
                try {
                    switch (this.dataScope) {
                        case 1: // 集团
                            this.searchJson.branch_id = ''
                            this.searchJson.school_id = ''
                            break;
                        case 2: // 分公司
                            this.searchJson.branch_id = u.branch_id
                            this.searchJson.school_id = ''
                            break;
                        case 3: // 校区
                            this.searchJson.branch_id = u.branch_id
                            this.searchJson.school_id = u.school_id
                            break;
                        case 4: // 部门
                            if (u.school_id == 0 && u.branch_id == 0) {// 集团部门权限
                                this.searchJson.branch_id = ''
                                this.searchJson.school_id = ''
                            }
                            if (u.school_id == 0 && u.branch_id != 0) { // 分公司部门权限
                                this.searchJson.branch_id = u.branch_id
                                this.searchJson.school_id = ''
                            }
                            if (u.school_id != 0) { // 校区部门权限
                                this.searchJson.branch_id = u.branch_id
                                this.searchJson.school_id = u.school_id
                            }
                            break;
                        case 7: // 个人
                            this.searchJson.branch_id = ''
                            this.searchJson.school_id = ''
                            break;
                        default:
                            this.searchJson.branch_id = ''
                            this.searchJson.school_id = ''
                    }
                } catch (err) {
                    console.log(err)
                }
            }
        }
    }
}
const loginPersonalAuthority = {
    data () {
        return {
            loading: false, //列表加载loading
            isData: true,
            filterBranchSchool: true, // 带分公司校区筛选
            tableData: [], //列表数据集
            branchOption: [], //分公司集
            schoolOption: [], //校区集
            isDefaultBranchSchool: true, // 分公司校区默认赋值
            dataScope: store.getters['auth/roleCacheData'].rights[this.$route.path] ?
                store.getters['auth/roleCacheData'].rights[this.$route.path].data_scope
                : 7, //数据范围
        }
    },
    created () {
        this.branchOption = getConstantByKeyword('filiale')
        if (this.WEIGHT) {//  任务模块添加的判断
            if (this.dataScope == 1) {
                this.isDefaultBranchSchool = false
                this.isData = false
            }
        }
        this.authDataScopeMisstion()
    },
    mounted () {
        this.isData && this.getList()
    },
    watch: {
        /* userMess: {
            handler(newVal, oldVal) {
                this.$nextTick(() => {
                    this.authDataScopeMisstion() // 新的权限判断
                })
            },
            immediate: true
        }, */
        branch_id: {
            handler (newVal, oldVal) {
                if (this.branchOption && this.branchOption.length) {
                    if (oldVal) {
                        this.searchJson.school_id = ''
                    }
                    this.getSchoolList(newVal)
                }
            },
            immediate: true
        }
    },
    computed: {
        branch_id () {
            return this.searchJson.branch_id
        }
    },
    methods: {
        getSchoolList (val) {
            let result = this.branchOption
            if (!val) {
                this.schoolOption = []
                this.searchJson.school_id = ''
                return false
            }
            this.schoolOption = result.filter(item => {
                return item.id == val
            })[0].child.filter(item => {
                return item.dep_type == 3
            })
        },
        getList () {
            this.searchJson.page = this.pagingObj.currentPage || 1
            this.loading = true
            this.tableData = []
            let tempSearchJson = getDisposeSearchCriteria(this.searchJson, this.time, this.inputDate)
            if (this.statisticsCustomerSchoolStatus) {
                this.statisticsCustomerSchoolStatus(tempSearchJson)
            }
            this.fetch(model[this.listUrl], {
                params: tempSearchJson
            }).then(res => {
                // res.data-->带分页的返回数据赋值 res-->不带分页的返回数据赋值
                this.tableData = res.data || res
                if (res.totalStatis) {// 带统计的返回数据
                    this.statisticArray = res.totalStatis
                }
                this.pagingObj = this.updatePagedData(this.pagingObj, res)
                this.loading = false
                if (this.$refs.selectRow && this.tableData.length && this.currentRowKey) {// 设置高亮行 this.currentRowKey
                    let row = this.tableData.filter(item => item.student_school_id == this.currentRowKey)[0]
                    this.$refs.selectRow.setCurrentRow(row)
                }
            }, data => {
                this.loading = false
                this.$message({
                    message: data,
                    type: 'error'
                })
            })
        },
        authDataScopeMisstion () {
            const u = this.userMess
            const { branch_id, school_id } = u
            let bid = branch_id || '', sid = school_id || ''
            if (this.dataScope && this.filterBranchSchool) {
                if (!bid && this.isDefaultBranchSchool) {
                    /* 获取第一个分公司id */
                    bid = this.branchOption[0].id
                }
                if (!sid && this.isDefaultBranchSchool) {
                    this.getSchoolList(bid)
                    /* 获取第一个校区id */
                    sid = this.schoolOption[0].id
                }
                this.searchJson.branch_id = bid
                this.searchJson.school_id = sid
                /* try{
                    switch(this.dataScope){
                        case 1: // 集团
                            this.searchJson.branch_id = bid
                            this.searchJson.school_id = sid
                            break;
                        case 2: // 分公司
                            this.searchJson.branch_id = bid
                            this.searchJson.school_id = sid
                            break;
                        case 3: // 校区
                            this.searchJson.branch_id = bid
                            this.searchJson.school_id = sid
                            break;
                        case 4: // 部门
                            if (u.school_id == 0 && u.branch_id == 0) {// 集团部门权限
                                this.searchJson.branch_id = bid
                                this.searchJson.school_id = sid
                            } 
                            if (u.school_id == 0 && u.branch_id != 0) { // 分公司部门权限
                                this.searchJson.branch_id = u.branch_id
                                this.searchJson.school_id = ''
                            }
                            if (u.school_id != 0) { // 校区部门权限
                                this.searchJson.branch_id = u.branch_id
                                this.searchJson.school_id = u.school_id
                            }
                            break;
                        case 7: // 个人
                            this.searchJson.branch_id = bid
                            this.searchJson.school_id = sid
                            break;
                        default: 
                            this.searchJson.branch_id = bid
                            this.searchJson.school_id = sid
                    }
                }catch(err){
                    console.log(err)
                } */
            }
        }
    }
}
/*处理搜索条件、期待服务端优化，优化后可省略此段过程*/


const exportExcel = {
    methods: {
        importHandle (obj) {
            if (typeof obj !== 'object') { return false }
            let url = '',
                type = obj.type,
                params = getDisposeSearchCriteria(this.searchJson, this.time, this.inputDate)
            if (type == 72) {
                let result = deepCopy(this.searchJson)
                delete result['push_time']
                delete result['commit_time']
                delete result['check_time']
                // 时间
                if (this.searchJson.push_time && this.searchJson.push_time.length) {
                    result.push_start_time = this.searchJson.push_time[0]
                    result.push_end_time = this.searchJson.push_time[1]
                }
                if (this.searchJson.commit_time && this.searchJson.commit_time.length) {
                    result.commit_start_time = this.searchJson.commit_time[0]
                    result.commit_end_time = this.searchJson.commit_time[1]
                }
                if (this.searchJson.check_time && this.searchJson.check_time.length) {
                    result.check_start_time = this.searchJson.check_time[0]
                    result.check_end_time = this.searchJson.check_time[1]
                }
                params = result
            }
            //带年月日不同时间类型的导出处理 start
            if (this.tabType) {
                delete params['date']
                switch (this.tabType) {
                    case 'date':
                        params.year_months_day = this.searchJson.date
                        params.time_type = 1
                        delete params['year_months']
                        delete params['year']
                        break
                    case 'month':
                        params.year_months = this.searchJson.date
                        params.time_type = 2
                        delete params['year_months_day']
                        delete params['year']
                        break
                    case 'year':
                        params.year = this.searchJson.date
                        params.time_type = 3
                        delete params['year_months']
                        delete params['year_months_day']
                        break
                }
            }
            //带年月日不同时间类型的导出处理 end
            url = downLoad[type]
            if (url) {
                obj.downLoading = true
                const loading = this.$loading({
                    lock: true,
                    text: '正在下载，请稍后...',
                    background: 'rgba(0, 0, 0, 0.7)'
                })
                let searchObj = obj.params ? deepCopy(obj.params) : deepCopy(params)
                Object.keys(searchObj).map(key => {
                    if (!searchObj[key]) {
                        delete searchObj[key]
                    }
                    if (key == 'page' || key == 'page_size') {
                        delete searchObj[key]
                    }
                })
                this.fetch(model[url], {
                    params: searchObj
                }).then(res => {
                    if (!res.file_path) {
                        this.$message({
                            message: '需要导出的信息不存在',
                            type: 'warning'
                        })
                        obj.downLoading = false
                        loading.close()
                        return false
                    }
                    let downloadElement = document.createElement('a')
                    let href = res.file_path // 创建下载的链接
                    downloadElement.style.display = 'none'
                    downloadElement.href = href
                    document.body.appendChild(downloadElement)
                    downloadElement.click() // 点击下载
                    document.body.removeChild(downloadElement) // 下载完成
                    loading.close()
                    obj.downLoading = false
                }, data => {
                    this.$message({
                        message: data,
                        type: 'error'
                    })
                    obj.downLoading = false
                    loading.close()
                })
            } else {
                console.log('不能识别的导出类型：' + type)
            }
        }
    }
}

export {
    userMess,
    tableConstant,
    submitIng,
    filialeAndSchoolSearch,
    exportExcel,
    loginPersonalAuthority,
}



// WEBPACK FOOTER //
// ./src/mixins/mixin.js